import React from 'react';
import { Button, Row } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPause, faPlay, faSplit, faPlus } from '@fortawesome/pro-solid-svg-icons';

import { checkCanPauseAutomation, checkCanSplitBill, checkCanTotalizeBill } from './helpers';

export default function BillAdvancedOptions(props) {
  const { bill, isSaving, handlePauseAutomation, handleSplitProviderBill, handleTotalizeProviderBill } =
    props;


  return (
    <Row>
      {checkCanPauseAutomation(bill) && (
        <div
          title={
            bill.pause_automation
              ? 'Resume Automation'
              : 'Pause Automation'
          }
        >
          <Button
            size='sm'
            style={{ marginLeft: '10px' }}
            disabled={
              isSaving
            }
            onClick={() => handlePauseAutomation(bill)}
          >
            <FontAwesomeIcon
              style={{
                fontSize: '21px',
                lineHeight: 'inherit',
                paddingTop: '2px',
              }}
              icon={bill.pause_automation ? faPlay : faPause}
            />
          </Button>
        </div>
      )}
      {checkCanSplitBill(bill) && (
        <div
          title={
            bill.provider_split_bill_parent === null
              ? 'Split Bill'
              : 'Bill cannot be split further'
          }
        >
          <Button
            size='sm'
            style={{ marginLeft: '10px' }}
            disabled={isSaving || bill.provider_split_bill_parent !== null}
            onClick={() => handleSplitProviderBill(bill.provider_bill_id)}
          >
            <FontAwesomeIcon
              style={{
                fontSize: '21px',
                lineHeight: 'inherit',
                paddingTop: '2px',
              }}
              icon={faSplit}
            />
          </Button>
        </div>
      )}
      {checkCanTotalizeBill(bill) && (
        <div
          title={'Totalize Bill'}
        >
          <Button
            size='sm'
            style={{ marginLeft: '10px' }}
            disabled={isSaving}
            onClick={() => handleTotalizeProviderBill(bill.provider_bill_id)}
          >
            <FontAwesomeIcon
              style={{
                fontSize: '21px',
                lineHeight: 'inherit',
                paddingTop: '2px',
              }}
              icon={faPlus}
            />
          </Button>
        </div>
      )}
    </Row>
  );
}
